import React, { useState, memo, useMemo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { formatPhoneNumber } from 'Utils/Formatters'

import DeleteIcon from 'Assets/Images/icons/delete'
import CheckedIcon from 'Assets/Images/icons/checked'
import ForbiddenIcon from 'Assets/Images/icons/forbidden'
import ArrowIcon from 'Assets/Images/icons/arrow'
import EyeIcon from 'Assets/Images/icons/eye'
import { updateAmbassadorByIdGraphQL } from '../../../../../../../../Reducers/Ambassador/actions'
import { Checkbox } from '../../../../../../../../Components/Form'
import { dateFormatter } from '../../../index'

import style from './style'
import { BRAND_AMBASSADOR_STATUS_ENUM } from '../../../../../../../../shared/constants'

function ColumnItem({
  provided,
  snapshot,
  columnName,
  item,
  onDelete,
  url,
  name,
  onDocumentsModalOpen,
  onApprovedModalOpen,
  onAttendantUpdate,
  isESCountry,
}) {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isToggleDocuments, setIsToggleDocuments] = useState(false)

  const noPipeLineUrl = url.endsWith('pipeline') ? url.slice(0, -9) : url

  const {
    isShowPhone,
    isShowDocuments,
    isShowDelete,
    isShowAttendedOnboarding,
    isShowOnboardingDate,
    isShowOnboardingType,
    googleData,
    documents,
    preSignupStep,
    handleDocumentsModals,
  } = useMemo(() => {
    const { status, googleEventMetadata } = item

    let googleData = {}
    if (
      googleEventMetadata &&
      status !== BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED
    ) {
      const {
        status,
        start: { dateTime, timeZone },
        extendedProperties: {
          private: { type },
        },
      } = googleEventMetadata

      googleData = {
        start: `${dateFormatter(
          new Date(dateTime).toLocaleString('en-US', {
            timeZone,
          }),
        )} ${new Date(dateTime).toLocaleTimeString('en-US')}`,
        status,
        type,
      }
    }

    const isShowPhone = status !== BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED
    const isShowDelete = status !== BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE
    const isShowDocuments =
      status !== BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED &&
      status !== BRAND_AMBASSADOR_STATUS_ENUM.PENDING &&
      status !== BRAND_AMBASSADOR_STATUS_ENUM.BOOKED_MEETING &&
      status !== BRAND_AMBASSADOR_STATUS_ENUM.QUIZ_IN_PROGRESS
    const isShowAttendedOnboarding =
      (status !== BRAND_AMBASSADOR_STATUS_ENUM.PENDING &&
        status !== BRAND_AMBASSADOR_STATUS_ENUM.BOOKED_MEETING &&
        status !== BRAND_AMBASSADOR_STATUS_ENUM.VIDEO_ONBOARDING_IN_PROGRESS &&
        status !== BRAND_AMBASSADOR_STATUS_ENUM.UNINTERESTED &&
        !item.fromVideoOnboarding) ||
      isESCountry

    let handleDocumentsModals
    if (status === BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE) {
      handleDocumentsModals = () => onDocumentsModalOpen(item, true)
    }

    if (status === BRAND_AMBASSADOR_STATUS_ENUM.WAITING_FOR_REVIEW) {
      handleDocumentsModals = () => onApprovedModalOpen(item)
    }

    const isShowOnboardingDate = googleData.start && columnName === 'booked'

    const isShowOnboardingType = googleData.type && columnName === 'booked'

    const {
      documents: { latestDocuments: documents = [] },
    } = item

    let preSignupStep
    if (columnName == 'refused') {
      preSignupStep = ''
    } else if (columnName == 'booked') {
      preSignupStep = 'S6'
    } else if (columnName == 'interested') {
      preSignupStep = 'S4'
    } else if (columnName == 'test') {
      preSignupStep = 'S4'
    } else if (documents.length) {
      preSignupStep = 'ID1'
    }

    return {
      preSignupStep,
      isShowPhone,
      isShowDocuments,
      isShowDelete,
      isShowAttendedOnboarding,
      isShowOnboardingDate,
      isShowOnboardingType,
      googleData,
      documents,
      handleDocumentsModals,
    }
  }, [item])

  const classes = useColumnItemStyle({
    isDragging: snapshot.isDragging,
    draggableStyle: provided.draggableProps.style,
  })

  const handleDelete = useCallback(() => onDelete({ ...item, columnName }), [
    item,
    onDelete,
  ])

  const handleToggleDocuments = useCallback(
    () => setIsToggleDocuments(!isToggleDocuments),
    [isToggleDocuments],
  )

  const redirectToUserDitails = useCallback(
    () => history.push(`${noPipeLineUrl}/${item.id}`),
    [item.id, noPipeLineUrl],
  )

  const toggleAttendantOnboarding = async () => {
    const isChecked = !item.isAttendantOnboarding
    await dispatch(
      updateAmbassadorByIdGraphQL(
        item.id,
        {
          isAttendantOnboarding: isChecked,
        },
        {
          onSuccess: () => {
            onAttendantUpdate(name, item.id, isChecked)
          },
        },
      ),
    )
  }

  return (
    <div
      onDoubleClick={redirectToUserDitails}
      className={classes.body}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      {item.onChangeStep && (
        <div className={classes.stepDate}>{item.onChangeStep}</div>
      )}
      <div className={classes.header} cypress_id={'BANameInPipeline'}>
        <Link to={`${noPipeLineUrl}/${item.id}`} className={classes.name}>
          {item.firstName} {item.lastName}
        </Link>
        <div className={classes.controls}>
          <div className={classes.memberSince}>{item.memberSinceFormated}</div>
          {handleDocumentsModals && (
            <EyeIcon
              onClick={handleDocumentsModals}
              fill="#004360"
              className={classes.handleDocumentsModalsCursor}
            />
          )}
          {isShowDocuments && (
            <div
              onClick={handleToggleDocuments}
              className={classes.documentsList}
            >
              {preSignupStep}
              {isToggleDocuments ? (
                <ArrowIcon
                  fill="#7f8fa4"
                  className={
                    classes.documentsListCursor +
                    ' ' +
                    classes.documentsListCursorOpen
                  }
                />
              ) : (
                <ArrowIcon
                  fill="#7f8fa4"
                  className={classes.documentsListCursor}
                />
              )}
            </div>
          )}
          {!isShowDocuments && (
            <div className={classes.documentsList}>{preSignupStep}</div>
          )}
          {isShowDelete && (
            <div
              onClick={handleDelete}
              className={classes.deleteUser}
              cypress_id={'deleteUser: ' + item.id}
            >
              <DeleteIcon height="12px" fill="#808792" />
            </div>
          )}
        </div>
      </div>
      <div className={classes.content}>
        {isShowAttendedOnboarding && (
          <div className={classes.attendedOnboarding}>
            <Checkbox
              input={{
                value: item.isAttendantOnboarding,
                onClick: toggleAttendantOnboarding,
              }}
              label={isESCountry ? 'Is Autónomo' : 'Attended Onboarding'}
              checkboxSize="18px"
              fontSize="13px"
              labelColor="#7f8fa4"
            />
          </div>
        )}
        {item.status ===
          BRAND_AMBASSADOR_STATUS_ENUM.VIDEO_ONBOARDING_IN_PROGRESS && (
          <div>video onboarding, {item.videoType}</div>
        )}
        {isToggleDocuments &&
          documents.map((item, index) => (
            <div key={item.documentTypeName + index} className={classes.item}>
              <Link className={classes.documents} to={item.url}>
                {item.documentTypeName}
              </Link>
              <div className={classes.itemStatus}>
                <CheckedIcon height="7px" fill="#00b200" />
              </div>
            </div>
          ))}
        {isShowPhone && (
          <div className={classes.item}>
            <div className={classes.itemText}>
              {formatPhoneNumber(item.mobilePhone) || item.mobilePhone}
            </div>
          </div>
        )}
        {isShowOnboardingDate && (
          <div className={classes.item}>
            <div className={classes.itemText}>{googleData.start}</div>
            <div className={classes.itemStatus}>
              {googleData.status === 'confirmed' ? (
                <CheckedIcon height="7px" fill="#00b200" />
              ) : (
                <ForbiddenIcon height="7px" fill="#e80000" />
              )}
            </div>
          </div>
        )}
        {isShowOnboardingType && (
          <div className={classes.item}>
            <div className={classes.itemText}>
              {googleData.type === 'OFFLINE' ? 'Offline' : 'Online'}
            </div>
          </div>
        )}
        {item.previousStage && (
          <div className={classes.item}>
            <div className={classes.itemText}>{item.previousStage}</div>
          </div>
        )}
        {item.recruitmentChannel && (
          <div className={classes.item}>
            <div className={classes.itemText}>{item.recruitmentChannel}</div>
          </div>
        )}
        {item.fromVideoOnboarding && (
          <div className={classes.wrapperLabel}>
            <div className={classes.label}>
              video onboarding, {item.hasQuiz ? 'Q' : item.videoType}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const useColumnItemStyle = makeStyles(props => ({
  ...style,
  body: {
    ...style.body,
    boxShadow: props.isDragging ? '1.7px 1.7px 8.6px rgba(0, 0, 0, 0.25)' : '',
    ...props.draggableStyle,
  },
}))

export default memo(ColumnItem)
